import React, { useEffect, useState } from "react";
import PropTypes from "kf-proptypes/widgets";
import { Trans } from "@lingui/macro";

import { BaseDropdown } from "../dropdown/base.jsx";
import { DatePanel } from "./datepanel.jsx";
import { Button, BUTTON_SIZES } from "../../inputs/button/index.jsx";
import { DropdownTarget } from "../dropdowntarget/index.jsx";
import { OverflowText } from "@widgets/datadisplay/overflowtext/index.jsx";

import styles from "./daterangedropdown.css";

function formatDate(date) {
  return `${date.format("DD/MM/YYYY")}`;
}

/**
 * The DateDropdown component provides a dropdown interface for selecting a date with custom range.
 */

export function DateDropdown(props) {
  const {
    targetRenderer,
    onChange,
    startsAt,
    endsAt,
    listRenderer,
    value,
    onOpen,
    onClose
  } = props;
  const [openCustomDate, setOpenCustomDate] = useState(false);
  const [customDate, setCustomDate] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const switchToDateSelector = () => {
    setOpenCustomDate(true);
  };
  const defaultTargetRenderer = () => {
    return (
      <DropdownTarget isOpen={isOpen}>
        <OverflowText>{value && value.label}</OverflowText>
      </DropdownTarget>
    );
  };
  useEffect(
    function initEffect() {
      value && setCustomDate(value.date);
    },
    [value]
  );

  return (
    <BaseDropdown
      targetRenderer={targetRenderer || defaultTargetRenderer}
      visible={true}
      onOpen={() => {
        onOpen && onOpen({ switchToDateSelector });
        setIsOpen(true);
      }}
      onClose={() => {
        setOpenCustomDate(false);
        onClose && onClose();
        setIsOpen(false);
      }}
      listRenderer={({ closePopup }) => {
        return (
          <React.Fragment>
            {!openCustomDate &&
              listRenderer({ closePopup, switchToDateSelector })}
            {openCustomDate && (
              <div className={styles.daterangedropdown}>
                <DatePanel
                  onChange={(date) => {
                    setCustomDate(date);
                  }}
                  startsAt={startsAt}
                  endsAt={endsAt}
                  value={customDate}
                />
                <div className={styles.action}>
                  <Button
                    size={BUTTON_SIZES.SMALL}
                    disabled={!customDate}
                    onClick={(e) => {
                      onChange &&
                        onChange({
                          date: customDate,
                          label: formatDate(customDate)
                        });
                      closePopup();
                      onClose && onClose();
                      setOpenCustomDate(false);
                      setIsOpen(false);
                    }}
                  >
                    <Trans>Done</Trans>
                  </Button>
                </div>
              </div>
            )}
          </React.Fragment>
        );
      }}
    />
  );
}

DateDropdown.propTypes = {
  /**
   * User can customise the target of dropdown
   */
  targetRenderer: PropTypes.func,
  /**
   * Dropdown customise by the list
   */
  listRenderer: PropTypes.func,
  /**
   * User cannot select date before starts at
   */
  startsAt: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool,
    PropTypes.object
  ]),
  /**
   * User cannot select date past ends at
   */
  endsAt: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.bool,
    PropTypes.object
  ]),
  /**
   * Trigger when user opens the dropdown
   */
  onOpen: PropTypes.func,
  /**
   * Trigger when user close the dropdown
   */
  onClose: PropTypes.func,
  /**
   * If user select the value this onchange prop will trigger
   */
  onChange: PropTypes.func,
  /**
   * Default value of the fields
   */
  value: PropTypes.shape({
    date: PropTypes.string,
    label: PropTypes.string
  })
};
